export default __webpack_public_path__ + "static/media/Earthen-and-Teal-Dangling-Earrings.e4284606.jpg";